import { IColumn } from '@fluentui/react';
import React from 'react';

import { ApplicationDecisionDto } from 'api-client';

import DetailsList from 'common/controls/lists/DetailsList';
import { SubSectionHeading } from 'common/layout/SectionHeadings';

import { useMedia } from '../../../common/layout/MediaHook';

interface Props {
  decisions: ApplicationDecisionDto[];
}

const DecisionDetailsList: React.FC<Props> = (props) => {
  return (
    <>
      <SubSectionHeading
        title="Application Decisions"
        moreOrLess={{
          less: <LessDetails {...props} />,
          more: <MoreDetails {...props} />,
        }}
        expanded
      />
    </>
  );
};

const LessDetails = ({ decisions }: Props) => {
  const { isMobile } = useMedia();
  return (
    <>
      <DetailsList
        id={'less-decision-details-table'}
        data-automation-id={'Application-decision-details'}
        items={decisions.slice(0, 1)}
        columns={columns(isMobile)}
      />
    </>
  );
};

const MoreDetails = ({ decisions }: Props) => {
  const { isMobile } = useMedia();
  return (
    <>
      <DetailsList
        id={'more-decision-details-table'}
        data-automation-id={'more-decision-details-table'}
        items={decisions.slice(1)}
        columns={columns(isMobile)}
        isHeaderVisible={false}
      />
    </>
  );
};

const columns = (isMobile: boolean): IColumn[] => [
  {
    key: 'decisionDate',
    name: 'Date',
    onRender: (item: ApplicationDecisionDto) => item.decisionDate,
    minWidth: isMobile ? 0 : 130,
    maxWidth: 150,
    isResizable: true,
  },
  {
    key: 'createdUserName',
    name: 'Name',
    onRender: (item: ApplicationDecisionDto) => item.createdUserName,
    minWidth: isMobile ? 0 : 140,
    maxWidth: 160,
    isResizable: true,
  },
  {
    key: 'createdUserRole',
    name: 'User Role',
    onRender: (item: ApplicationDecisionDto) => item.createdUserRole,
    minWidth: isMobile ? 0 : 150,
    maxWidth: 160,
    isResizable: true,
  },
  {
    key: 'createdClient',
    name: 'Organisation/Applicant',
    onRender: (item: ApplicationDecisionDto) => item.createdClient,
    minWidth: isMobile ? 0 : 220,
    maxWidth: 240,
    isMultiline: true,
    isResizable: true,
  },
  {
    key: 'fileNo',
    name: 'Reference file no.',
    onRender: (item: ApplicationDecisionDto) => (item.fileNo ? item.fileNo : '-'),
    minWidth: isMobile ? 0 : 200,
    maxWidth: 220,
    isMultiline: true,
    isResizable: true,
  },
  {
    key: 'decision',
    name: 'Action',
    onRender: (item: ApplicationDecisionDto) => (item.decision ? item.decision : '-'),
    minWidth: isMobile ? 0 : 120,
    maxWidth: 140,
    isResizable: true,
  },
  {
    key: 'notes',
    name: 'Decision Notes',
    onRender: (item: ApplicationDecisionDto) => (item.notes ? item.notes : '-'),
    minWidth: isMobile ? 0 : 300,
    maxWidth: 320,
    isResizable: true,
    isMultiline: true,
  },
];

export default DecisionDetailsList;
